export default "__VITE_ASSET__CaXn3bii__"